import { configureStore } from '@reduxjs/toolkit';
import mainReducer from '../features/mainSlice';
import modalReducer from '../features/modalSlice';
import notifierReducer from '../features/notifierSlice';
import organizationReducer from '../features/organizationSlice';
import superMarketReducer from '../features/superMarketSlice';

// 沒事不要加reducer除非必要，請找其他工程師討論
export default configureStore({
  reducer: {
    ma: mainReducer,
    notifier: notifierReducer,
    modal: modalReducer,
    organization: organizationReducer,
    superMarket: superMarketReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
